<template>
  <div class="container-fluid bg-light">
    <div class="row title-card">
      <div class="col-10 text-left text-dark"><h4>Cadastro de Loja</h4></div>
      <div class="col-2 text-right">
        <b-link class="text-dark" :to="{ name: 'home' }">
          <icon name="times" scale="2"></icon>
        </b-link>
      </div>
    </div>
    <div class="row">
      <div class="col-12 col-md-8 col-lg-6 offset-md-2 offset-lg-3 offset-xl-3 text-right">
        <b-btn v-b-modal.novaLoja variant="success">Nova Loja</b-btn>
      </div>
    </div>
    <div class="row pt-2">
      <div class="col-12 col-md-8 col-lg-6 offset-md-2 offset-lg-3 offset-xl-3">
        <table class="table table-striped">
          <thead>
          <tr>
            <th scope="col">Nome</th>
            <th scope="col" class="text-right">Opções</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(store, index) in stores" v-bind:key="'store-'+index">
            <td class="align-middle">{{ store.nm_store }}</td>
            <td>
              <div class="btn-toolbar float-right" role="toolbar">
                <div class="btn-group" role="group">
                  <button type="button" class="btn btn-primary" @click="setStore(store)" v-b-modal.editarLoja>
                    <icon name="pencil" scale="1.2" class="align-middle"></icon>
                  </button>
                  <b-btn v-b-modal.editAvalInicio variant="warning text-white" @click="setStore(store)">
                    <icon name="hourglass" scale="1.2" class="align-middle"></icon>
                  </b-btn>
                  <b-btn v-b-modal.editAvalFerias variant="info" @click="setStore(store)">
                    <icon name="clipboard" scale="1.2" class="align-middle"></icon>
                  </b-btn>
                  <b-button v-b-tooltip.hover class="btn btn-success" @click="changeStatus(store)"
                            v-if="store.st_store == '1'" title="Desativar">
                    <icon name="check" scale="1.2" class="align-middle"></icon>
                  </b-button>
                  <b-button v-b-tooltip.hover class="btn btn-danger" @click="changeStatus(store)"
                            v-if="store.st_store == '0'" title="Ativar">
                    <icon name="ban" scale="1.2" class="align-middle"></icon>
                  </b-button>
                </div>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- Modal Nova Loja -->
    <b-modal id="novaLoja" ref="modalNew" title="Nova Loja" @ok="newStore" @hidden="clearData" no-close-on-backdrop>
      <form @submit="onSubmit">
        <div class="form-group">
          <label for="nomeLoja">Nome</label>
          <input type="text" class="form-control" id="nomeLoja" v-model="novaLoja.nome" required>
        </div>
        <div class="form-group">
          <label for="nomeLoja">Usuário da Loja</label>
          <select class="custom-select" v-model="novaLoja.usuario" required>
            <option v-for="(user, index) in users" v-bind:key="'users-'+index" v-if="user.stores == '0'"
                    v-bind:value="user.id_user">{{ user.nm_user }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <label for="nomeModelo">Modelo de Check</label>
          <select class="custom-select" v-model="novaLoja.modelo" required>
            <option v-for="(model, index) in models" v-bind:key="'model-'+index" v-bind:value="model.id_model">
              {{ model.nm_model }}
            </option>
          </select>
        </div>
      </form>
    </b-modal>

    <!-- Modal Editar Loja -->
    <b-modal id="editarLoja" ref="modalEdit" title="Editar Loja" @ok="editStore" @hidden="clearData"
             no-close-on-backdrop>
      <form @submit="onSubmit">
        <div class="form-group">
          <label for="nomeLoja">Nome</label>
          <input type="text" class="form-control" id="nomeLoja" v-model="editarLoja.nome" required>
        </div>
        <div class="form-group">
          <label for="nomeLoja">Usuário da Loja</label>
          <select class="custom-select" v-model="editarLoja.usuario" required>
            <option v-for="(user, index) in users" v-bind:key="'user-'+index"
                    v-if="user.id_user == editarLoja.usuario || user.stores == 0" v-bind:value="user.id_user">
              {{ user.nm_user }}
            </option>
          </select>
        </div>
        <div class="form-group">
          <label for="nomeModelo">Modelo de Check</label>
          <select class="custom-select" v-model="editarLoja.modelo" required>
            <option v-for="(model, index) in models" v-bind:key="'model-'+index" v-bind:value="model.id_model">
              {{ model.nm_model }}
            </option>
          </select>
        </div>
      </form>
    </b-modal>

    <!-- Editar Ferias Avaliação -->
    <b-modal id="editAvalFerias" ref="modalEditAvalFerias" title="Período de Férias" @ok="setFerias"
             @shown="getListFerias" @hidden="clearData" v-if="level == 'supervisor'" no-close-on-backdrop>
      <form @submit="onSubmit">
        <div class="form-group">
          <label for="iniFerias">Início</label>
          <input type="date" class="form-control" id="iniFerias" v-model="editarLoja.iniFerias">
          <label for="fimFerias">Fim</label>
          <input type="date" class="form-control" id="fimFerias" v-model="editarLoja.fimFerias">
        </div>
        <div class="row pt-3">
          <div class="col-12"><h4 class="text-info-h1">Histórico</h4></div>
        </div>
        <div class="row pt-1 pb-1" v-for="(list, index) in listFerias" v-bind:key="'r-'+index" v-if="index < 10">
          <b-col cols="6" class="text-center">
            {{ list.desc }}
            <button type="button" class="close" aria-label="Fechar" @click="deleteFerias(list.id)">
              <span aria-hidden="true">&times;</span>
            </button>
          </b-col>
        </div>
      </form>
    </b-modal>

    <!-- Editar Reset Avaliação  -->
    <b-modal id="editAvalInicio" ref="modalEditAvalInicio" title="Período de Avaliação" @ok="iniAvaliacao"
             @shown="getInicioAvaliacao" @hidden="clearData" v-if="level == 'supervisor'" no-close-on-backdrop>
      <form @submit="onSubmit">
        <div class="form-group">
          <label for="iniAval">Início</label>
          <input type="date" class="form-control" id="iniAval" v-model="editarLoja.iniAval">
        </div>
      </form>
    </b-modal>

  </div>
</template>

<script>
import {http} from '../http'
import swal from 'sweetalert'
import Icon from 'vue-awesome'

export default {
  components: {Icon},
  data() {
    return {
      level: localStorage.getItem('level'),
      admin: localStorage.getItem('admin'),
      novaLoja: {nome: null, usuario: null},
      editarLoja: {id: null, status: null, nome: null, usuario: null, iniAval: null, iniFerias: null, fimFerias: null},
      users: [],
      models: [],
      stores: [],
      txt: '',
      listFerias: [],
    }
  },
  beforeCreate() {
    // Verifica se existe o item token no localStorage.
    if (!localStorage.getItem('token')) this.$router.push('home')
    if (localStorage.getItem('admin') == 'false') this.$router.push('home')
  },
  mounted() {
    this.up();
  },
  methods: {
    onSubmit(evt) {
      evt.preventDefault();
    },
    newStore(evt) {
      evt.preventDefault();
      if (!this.novaLoja.nome || !this.novaLoja.usuario || !this.novaLoja.modelo) {
        swal({
          icon: "error",
          title: 'Erro...',
          text: 'Informe o nome, usuário e modelo da loja de acesso.',
          dangerMode: true,
        })
      } else {
        // Requisição para gravar a nova loja.
        http.post('/store/save', {
          nome: this.novaLoja.nome,
          usuario: this.novaLoja.usuario,
          modelo: this.novaLoja.modelo
        })
          .then(response => {
            this.clearData()
            this.$refs.modalNew.hide()
            swal({
              icon: 'success',
              title: 'Ok!',
              text: 'Nova loja cadastrada.'
            })
            this.up();
          })
          .catch(error => {
            swal({
              type: 'error',
              title: 'Erro...',
              text: error.response.data.mensagem
            })
          })
      }
    },
    editStore(evt) {
      evt.preventDefault();
      if (!this.editarLoja.nome || !this.editarLoja.usuario || !this.editarLoja.modelo) {
        swal({
          icon: 'error',
          title: 'Erro...',
          text: 'Preencha as informações corretamente.',
          dangerMode: true,
        })
      } else {
        var json = {
          id: this.editarLoja.id,
          status: this.editarLoja.status,
          nome: this.editarLoja.nome,
          usuario: this.editarLoja.usuario,
          modelo: this.editarLoja.modelo,
          iniAval: this.editarLoja.iniAval,
          iniFerias: this.editarLoja.iniFerias,
          fimFerias: this.editarLoja.fimFerias,
        };
        // Requisição para gravar as alterações.
        http.post('/store/update', json)
          .then(response => {
            this.clearData()
            this.$refs.modalEdit.hide()
            swal({
              icon: 'success',
              title: 'Salvo!',
              text: 'Informações gravadas com sucesso!'
            })
            this.up()
          })
          .catch(error => {
            swal({
              type: 'error',
              title: 'Erro...',
              text: error.response.data.mensagem
            })
          })
      }
    },
    changeStatus(store) {

      if (store.st_store == 1) {
        store.st_store = 0;
        this.txt = 'inativado';
      } else {
        store.st_store = 1;
        this.txt = 'Ativado';
      }

      var json = {
        id: store.id_store,
        status: store.st_store,
        nome: store.nm_store,
        usuario: store.id_user,
        modelo: store.id_model
      };
      // Requisição para inativar a loja.
      http.post('/store/update', json)
        .then(response => {
          swal({
            icon: 'success',
            title: 'Salvo!',
            text: 'Loja ' + this.txt + '.'
          })
          this.up();
        })
        .catch(error => {
          swal({
            type: 'error',
            title: 'Erro...',
            text: error.response.data.mensagem
          })
        })
    },
    iniAvaliacao(evt) {
      evt.preventDefault();

      if (this.editarLoja.iniAval == null || this.editarLoja.iniAval == "") {
        swal({
          icon: 'error',
          title: 'Existe uma inconsistência!',
          text: 'Preencha o campo "Início".'
        })
      } else {
        const date1 = new Date();
        const date2 = new Date(this.editarLoja.iniAval + " 23:59:00");

        if (date1.getTime() < date2.getTime()) {
          swal({
            icon: 'error',
            title: 'Existe uma inconsistência!',
            text: 'O "Início" não pode ser maior que a data atual.'
          })
        } else {
          var json = {
            id: this.editarLoja.id,
            nome: this.editarLoja.nome,
            dateStart: this.editarLoja.iniAval
          };
          // Requisição para inativar a loja.
          http.post('/store/setAssessment', json)
            .then(response => {
              this.clearData()
              this.$refs.modalEditAvalInicio.hide()
              swal({
                icon: 'success',
                title: 'Período de Avaliação Atualizado!',
                text: 'Informações atualizadas com sucesso!'
              })
              this.up();
            })
            .catch(error => {
              swal({
                type: 'error',
                title: 'Erro...',
                text: error.response.data.mensagem
              })
            })
        }
      }
    },
    setFerias(evt) {
      evt.preventDefault();
      //console.log(this.editarLoja);

      if (this.editarLoja.iniFerias == null || this.editarLoja.fimFerias == null || (this.editarLoja.iniFerias > this.editarLoja.fimFerias)) {
        swal({
          icon: 'error',
          title: 'Existe uma inconsistência!',
          text: 'Por favor, preencha todos os campos corretamente.',
          dangerMode: true,
        })
      } else {
        var json = {
          id: this.editarLoja.id,
          nome: this.editarLoja.nome,
          dateStart: this.editarLoja.iniFerias,
          dateEnd: this.editarLoja.fimFerias
        };
        // Requisição para inativar a loja.
        http.post('/store/setHoliday', json)
          .then(response => {
            swal({
              icon: 'success',
              title: 'Período de Férias Cadastrado!',
              text: 'Informações atualizadas com sucesso!'
            })
            this.editarLoja.iniFerias = null
            this.editarLoja.fimFerias = null
            this.listFerias = null

            this.getListFerias()
            this.up();
          })
          .catch(error => {
            swal({
              type: 'error',
              title: 'Erro...',
              text: error.response.data.mensagem
            })
          })
      }
    },
    getListFerias() {
      http.get('/store/holiday/' + this.editarLoja.id).then(response => {
        this.listFerias = []
        response.data.forEach(ferias => {
          this.listFerias.push({id: ferias.id_results_aux, desc: ferias.nm_results_aux});
        })
        this.up();
      })
        .catch(error => {
          swal({
            type: 'error',
            title: 'Erro...',
            text: error.response.data.mensagem
          })
        })
    },
    deleteFerias(id) {
      http.delete('/store/holiday/' + id).then(response => {
        swal({
          icon: 'success',
          title: 'Período de Férias Removido!',
          text: 'Informações atualizadas com sucesso!'
        })
        this.getListFerias()
        this.up();
      })
        .catch(error => {
          swal({
            type: 'error',
            title: 'Erro...',
            text: error.response.data.mensagem
          })
        })
    },
    getInicioAvaliacao() {
      http.get('/store/assessment/' + this.editarLoja.id).then(response => {
        this.editarLoja.iniAval = response.data.dt_start;
      })
        .catch(error => {
          swal({
            type: 'error',
            title: 'Erro...',
            text: error.response.data.mensagem
          })
        })
    },
    setStore(store) {
      this.editarLoja.id = store.id_store
      this.editarLoja.status = store.st_store
      this.editarLoja.nome = store.nm_store
      this.editarLoja.usuario = store.id_user
      this.editarLoja.modelo = store.id_model
    },
    clearData(evt) {
      this.novaLoja.id = null
      this.novaLoja.status = null
      this.novaLoja.nome = null
      this.novaLoja.usuario = null
      this.editarLoja.id = null
      this.editarLoja.status = null
      this.editarLoja.nome = null
      this.editarLoja.usuario = null
      this.editarLoja.modelo = null
      this.editarLoja.iniAval = null
      this.editarLoja.iniFerias = null
      this.editarLoja.fimFerias = null
      this.listFerias = null
    },
    up() {
      http.get('/store/all/store').then(response => {
        this.stores = response.data;
      })
      http.get('/user/stores').then(response => {
        this.users = response.data;
      })
      http.get('/model/all').then(response => {
        this.models = response.data;
      })
    }
  }
}
</script>

<style scoped>
.container-fluid {
  min-height: 100vh;
}

.container-fluid .title-card {
  padding: 20px 0;
}

.container-fluid .title-card h4 {
  font-size: 1.5em;
  line-height: 40px;
}

.close {
  color: crimson;
  margin-top: -3px;
}

</style>



// WEBPACK FOOTER //
// src/components/Store.vue